import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { LandingPage } from './pages/LandingPage';
import { FAQPage } from './pages/FAQPage';
function PromptButton() {
  const handleClick = () => {
    if (process.env.NODE_ENV === 'development') {
      const confirmed = window.confirm('This will throw an error for debugging purposes. Continue?');
      if (confirmed) {
        const text = window.prompt('Enter debug text to throw:');
        if (text !== null) {
          throw new Error(text);
        }
      }
    }
  };
  // Only render in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }
  return <button onClick={handleClick} className="fixed right-0 top-0 z-50 w-4 h-4 opacity-0 cursor-default" aria-hidden="true" data-id="element-0">
      prompt
    </button>;
}
export function App() {
  return <HelmetProvider data-id="element-1">
      <Router data-id="element-2">
        <div className="flex flex-col min-h-screen bg-white" data-id="element-3">
          <Helmet data-id="element-4">
            <title data-id="element-5">Eedi Testbed Schools</title>
            <meta name="description" content="Join Eedi's Testbed Schools programme to enhance mathematics education through innovative approaches and research-backed methods." data-id="element-6" />
          </Helmet>
          <Header data-id="element-7" />
          <main className="flex-grow" data-id="element-8">
            <Routes data-id="element-9">
              <Route path="/" element={<LandingPage data-id="element-11" />} data-id="element-10" />
              <Route path="/faq" element={<FAQPage data-id="element-13" />} data-id="element-12" />
            </Routes>
          </main>
          <Footer data-id="element-14" />
          <PromptButton data-id="element-15" />
        </div>
      </Router>
    </HelmetProvider>;
}